import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import IndustrySidebar from "../pages/profile/industry/IndustrySidebar";
import { useSelectAccess } from "../store/stateFunctions";

const IndutryUserContainer = () => {
  document.title = "Industry Profile";
  const industry = useSelectAccess("Industry User");
  return (
    <>
      <Header />
      <div className="">
        {industry ? (
          <IndustrySidebar role="Industry User" />
        ) : (
          <Navigate to="/loginorg" />
        )}
        {/* <div className="col-md-10 py-2 ">
          <Outlet />
        </div> */}
      </div>
      <Footer />
    </>
  );
};

export default IndutryUserContainer;
